import { render, staticRenderFns } from "./CardAuth.vue?vue&type=template&id=63b5315e&lang=pug&"
import script from "./CardAuth.vue?vue&type=script&lang=js&"
export * from "./CardAuth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports